import React, {Component} from 'react';
import {VIEW_NAME, ROLES, OBJ_TYPE, DISPATCH_ID, config, SERVICE_API} from "../../libs/utils/Const";
import {Footer, ItemDetailsModal, ItemsList, NavBar, Session, ShoppingCartList,ItemsPromoModal, CommentsModal} from "../../components";
import {connect} from "react-redux";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import CurrencyFormat from 'react-currency-format';
import {Modal} from '../../components/index';
import CreditLimitModal from '../../components/CreditLimitModal';
import $ from 'jquery';
import ValidateOrderView from '../validateOrder/ValidateOrderView';

let apiClient = ApiClient.getInstance();
// Definicion de un arreglo para el producto Flete
let responseFlete = {ItemCode:'',ItemName:'',Price:'0',PriceList:'0',PurchaseLimit:''};
let modal = new Modal();

class ShoppingCartView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            itemsBonificacion :[],
            selectorType : null,
            itemDisparador: null,
            itemsRegalos : [],
            itemsRegalosSelect: [],
            EitemsRegalos : [],
            boxes:[],
            itemsNotificacion:[],
            variable: false,
        };
    };

    refeshState = (arrayRelacional,Notificacion) =>{
        const {history, shoppingCartReducer: {items}, itemsReducer: {addShoppingCart, deleteShoppingCart}} = this.props;
        const {itemsRegalosSelect} = this.state;

        let itemsPromo = [];
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            for (let index = 0; index < arrayRelacional.length; index++) {
                const element = arrayRelacional[index];
                if (element.itemDisparador ===  item.ItemCode && element.tipoSeleccion === 1) {
                    if(element.tipoDisparador === 2){
                        let result = itemsPromo.find(itemDisp => (itemDisp.itemDisparador !== item.ItemCode && itemDisp.idDisparador === element.idDisparador) );
                        if(!result){
                            element.bonificacion.cantidad*= element.homeItemQuantity;
                            itemsPromo.push(element);
                        }
                    }else if(element.tipoDisparador === 1){
                        element.bonificacion.cantidad*= element.homeItemQuantity;
                        itemsPromo.push(element);
                    }else if(element.tipoDisparador === 3){
                        let result = itemsPromo.find(itemDisp => (itemDisp.itemDisparador !== item.ItemCode  && itemDisp.idDisparador === element.idDisparador) );
                        if(!result){
                            itemsPromo.push(element);
                        }
                    } 
                }
            }
        }
        
        if(itemsPromo.length > 0){
            let boxes = [];
            for (let index = 0; index < arrayRelacional.length; index++) {
                const element = arrayRelacional[index];
                if(element.tipoSeleccion === 2){
                    let result = boxes.find(item => (item.itemDisparador === element.itemDisparador ));
                    if(!result){
                        boxes.push(element);
                    }
                }
            }
            for (let index = 0; index < itemsRegalosSelect.length; index++) {
                const element = itemsRegalosSelect[index];
                for (let index = 0; index < boxes.length; index++) {
                    const box = boxes[index];
                    if(element.itemDisparador === box.itemDisparador && element.idDisparador === box.idDisparador ){
                        boxes.splice(index,1);
                    }
                }
            }
            
            this.setState({
                itemsRegalos: itemsPromo,
                itemPromociones: arrayRelacional,    
                selectorType: 1,
                boxes: boxes,
                itemsRegalosSelect: [],
                itemsNotificacion: Notificacion
                
            });
            
        }else{
            let boxes = [];
            for (let index = 0; index < arrayRelacional.length; index++) {
                const element = arrayRelacional[index];
                if(element.tipoSeleccion === 2){
                    let result = boxes.find(item => (item.itemDisparador === element.itemDisparador ));
                    if(!result){
                        boxes.push(element)
                    }
                }
            }
            for (let index = 0; index < itemsRegalosSelect.length; index++) {
                const element = itemsRegalosSelect[index];
                for (let index = 0; index < boxes.length; index++) {
                    const box = boxes[index];
                    if(element.itemDisparador === box.itemDisparador && element.idDisparador === box.idDisparador ){
                        // boxes.splice(index,1);
                        // console.log('con>boxesDelete',boxes);
                    }
                }
            }
            
            this.setState({
                itemsRegalos: itemsPromo,
                itemPromociones: arrayRelacional,
                boxes: boxes,
                itemsRegalosSelect: [],
                itemsNotificacion: Notificacion,
               
            });
        }

      
       
    }
   
    selectItemsPromo = (itemsPromo,ItemCode) =>{
        const {itemPromociones,itemsRegalos} = this.state;
        if(itemsPromo.selectorType === 1){
            let arrayPromo = itemPromociones;
            for (let index = 0; index < arrayPromo.length; index++) {
                const promo = arrayPromo[index];
                for (let index = 0; index < promo.bonificacion.length; index++) {
                    const element = promo.bonificacion[index];
                    for (let index = 0; index < itemsPromo.length; index++) {
                        const items = itemsPromo[index];
                        if(element.bonificacion === items.idDetallesPromo){
                            promo.use = true;
                        }
                    }
                }
            }
            
            this.setState({
                itemsRegalos: [itemsPromo],
                itemPromociones: arrayPromo,    
                selectorType: itemsPromo.selectorType
            });
        }else{
            let boxes = [];
            for (let index = 0; index < itemPromociones.length; index++) {
                const element = itemPromociones[index];
                if(element.tipoSeleccion === 2){
                    if(element.idDisparador === itemsPromo.idDisparador && element.itemDisparador === ItemCode){
                        boxes.push(element);
                    }
                }
            }

            let items = [];
            let registrados = [];
            for (let index = 0; index < boxes.length; index++) {
                const element = boxes[index];
                // console.log('con>element',element.bonificacion.indexPack);
                let include = registrados.includes(element.bonificacion.indexPack);
                if(!include){

                let arrayTemp = boxes.filter(item => (item.bonificacion.indexPack === element.bonificacion.indexPack));
                registrados.push(element.bonificacion.indexPack);
                items.push(arrayTemp);
                
                }
            }
            //  console.log('con>items',items);

            this.setState({
                itemsBonificacion: items,
                selectorType: itemsPromo.selectorType,
                itemDisparador: itemsPromo.itemDisparador
            });
            $('#boniModal').modal('show');
        }
        
    }

    addItemsPromo = (item) =>{
        const {itemPromociones,itemsRegalos,itemDisparador,itemsBonificacion,boxes,itemsRegalosSelect} = this.state;

        for (let index = 0; index < item.length; index++) {
            const element = item[index];
            if(element.tipoDisparador !== 3){
                element.bonificacion.cantidad*= element.homeItemQuantity;
            }
            itemsRegalosSelect.push(element);
        }


        if(item[0].tipoDisparador === 1){
            this.setState( prevState => ({
                itemsRegalosSelect,
                boxes: prevState.boxes.filter(box => (box.itemDisparador !== item[0].itemDisparador )),
            }));
        }else if(item[0].tipoDisparador === 2 || item[0].tipoDisparador === 3){
            this.setState( prevState => ({
                itemsRegalosSelect,
                boxes: prevState.boxes.filter(box => (box.idDisparador !== item[0].idDisparador )),
            }));
        }
        $('#boniModal').modal('hide');
        
    }

    deleteItemPromo = (element) =>{
        element.bonificacion.cantidad  = element.bonificacion.cantidadEstatica;
        this.setState( (prevState) => ({
            boxes: [...prevState.boxes,element],
            itemsRegalosSelect: prevState.itemsRegalosSelect.filter(item => (item.itemDisparador !== element.itemDisparador )),
        }));
    }

    async componentDidMount(){
        //Asiganacion del producto que viene de SAP al front
        let responseApi = await this.getRegisterPack();
        //Tomando valores que vienen desde SAP
        let item_code = responseApi.data[0].ItemCode;
        let item_name = responseApi.data[0].ItemName;
        let price = responseApi.data[0].Price;
        let price_list = responseApi.data[0].PriceList;
        let purchase_limit = responseApi.data[0].PurchaseLimit;
        //Asigancion de los valores al arreglo del front
        responseFlete.ItemCode = item_code;
        responseFlete.ItemName = item_name;
        responseFlete.Price = price;
        responseFlete.PriceList = price_list;
        responseFlete.PurchaseLimit = purchase_limit;
        //console.log("Hola desde view",responseFlete);
        this.cargarDatos();
    }
    // Peticion del producto flete
    getRegisterPack = async () => {
        return await apiClient.getFlete();
    };
    createDocument = async () => {
        const {shoppingCartReducer: {items}, notificationReducer: {showAlert}, configReducer: {history},setItemsGift} = this.props;
        const {itemsRegalos,itemsRegalosSelect} = this.state;
        setItemsGift(itemsRegalos.concat(itemsRegalosSelect));
        //Se va el arregle de regalos al local
        localStorage.setItem(config.general.localStorageNamed + 'Gift', JSON.stringify(itemsRegalos));
        let errors = items.filter((item) => {
            return (!(!!item.OnHand) || (item.quantity > item.OnHand))
        });

        if (errors.length) return showAlert({
            message: 'Existen articulos agotados o en cantidad mayor en existencia. Para continuar elimine del carrito o paselos a su lista de deseos',
            type: 'warning',
            timeOut: 10000
        })

        history.goSelectAddress();
        //let response = await apiClient.createDocument({objType: OBJ_TYPE.ORDER, currency: 'MXP'});
    };

    mostrar = async () => {
        const { notificationReducer: {showAlert}} = this.props;
        const { Balance, CreditLine, boxes} = this.state;
        if(boxes.length > 0){
            boxes.map(articulosSeleccionados =>{
                showAlert({type: 'warning', message: 'No has seleccionado la bonificación del artículo: ' + articulosSeleccionados.itemDisparador, timeOut: 5000});
            })
            return;
        }
        
        let limit = Balance- CreditLine;
        if(limit>0){
            $('#creditLimitModal').modal('show');
        }
        else{
            this.createDocument();
        }        
    };

    changeQuantity = (index, item, newQuantity, addItem) => {
        const {setShoppingCart, itemsReducer: {addShoppingCart, deleteShoppingCart}, shoppingCartReducer: {items}} = this.props;
        
        items.map(itemFilter => {
            if (item.ItemCode === itemFilter.ItemCode) {
                itemFilter.quantity = newQuantity;
            }
        });

        setShoppingCart(items);

        if (!newQuantity) return;

        if (addItem) {
            addShoppingCart({item, quantity: (newQuantity)})
        } else {
            //deleteShoppingCart({item, deleteAll: false});
        }
    };

    renderShoppingCartTotal = () => {
        const {history, shoppingCartReducer: {items}, itemsReducer: {addShoppingCart, deleteShoppingCart}} = this.props;
        let subTotal = 0;
        let taxTotal = 0;
        let total = 0;
        let tax = 0;
        let localLanguage = '';
        let currency = '';
        //Variables para validacion del Flete
        let transport = 0;
        let taxTransport = 0;
        let limit = 0;
        items.map(item => {
            
            let totalPrice = Number((item.Price * item.quantity) - ((item.Price * item.quantity) * (item.Discount / 100)));
            subTotal += totalPrice;
            tax = item.taxRate;
            taxTotal += parseFloat(item.taxSum * item.quantity); // Number(item.taxSum * item.quantity);
            
            localLanguage = item.localLanguage;
            currency = item.currency;
        });
        let IGV = tax * subTotal / 100;
        //Asignacion de valores para el flete
        limit = parseInt(responseFlete.PurchaseLimit);
        transport = parseFloat(responseFlete.Price);
        taxTransport = parseFloat(transport*(tax*0.01));
        //Validacion del flete
        // if(subTotal < limit){
        //     taxTotal = taxTotal + taxTransport;
        //     total = subTotal + transport + taxTotal;
        // }else{
        //     transport = 0;
        //     total = subTotal + transport + taxTotal;
        // }
        total = subTotal + IGV;
        return (
            <div className="container" style={{fontSize: 18}}>
                <div className="row">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Subtotal: </span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            <CurrencyFormat 
                                value={subTotal} 
                                displayType={'text'} 
                                thousandSeparator={true} 
                                fixedDecimalScale={true} 
                                decimalScale={2} 
                                prefix={config.general.currency}>
                            </CurrencyFormat>
                        </span>
                    </div>
                </div>
                {/* <div className="row border-bottom">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Envío:</span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            {subTotal === 0?
                                <CurrencyFormat 
                                    value={0} 
                                    displayType={'text'} 
                                    thousandSeparator={true} 
                                    fixedDecimalScale={true} 
                                    decimalScale={2} 
                                    prefix={config.general.currency}>
                                </CurrencyFormat>:
                                <CurrencyFormat 
                                    value={transport} 
                                    displayType={'text'} 
                                    thousandSeparator={true} 
                                    fixedDecimalScale={true} 
                                    decimalScale={2} 
                                    prefix={config.general.currency}>
                                </CurrencyFormat>
                            }
                        </span>
                    </div>
                </div> */}
                <div className="row border-bottom">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">
                            I.G.V. ({tax}%): 
                        </span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            <CurrencyFormat 
                            //taxTotal
                                value={IGV} 
                                displayType={'text'} 
                                thousandSeparator={true} 
                                fixedDecimalScale={true} 
                                decimalScale={2} 
                                prefix={config.general.currency}>
                            </CurrencyFormat>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Total: </span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            {subTotal === 0?
                                <CurrencyFormat 
                                    value={0} 
                                    displayType={'text'} 
                                    thousandSeparator={true} 
                                    fixedDecimalScale={true} 
                                    decimalScale={2} 
                                    prefix={config.general.currency}>
                                </CurrencyFormat>:
                                <CurrencyFormat 
                                    value={total} 
                                    displayType={'text'} 
                                    thousandSeparator={true} 
                                    fixedDecimalScale={true} 
                                    decimalScale={2} 
                                    prefix={config.general.currency}>
                                </CurrencyFormat>
                            }
                        </span>
                    </div>
                </div>
            </div>
        )
    };

    sendToBackOrder = item => {
        // console.log('con< SenTo',item);
        const {itemsReducer: {addBackOrder, deleteShoppingCart}} = this.props;
        deleteShoppingCart({item, deleteAll: false});
        addBackOrder({item, quantity: (item.quantity || '1')})
    };

    cargarDatos = async () => {
        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        user = JSON.parse(user) || {};
        let limit = user.Balance- user.CreditLine;
        this.setState({
            Codigo: user.CardCode,
            CardName : user.CardName,    
            Balance : user.Balance ,
            CreditLine : user.CreditLine,
            Limit : limit
        });
    };

    renderShoppingCartDetail = () => {
        const {history, shoppingCartReducer: {items}, itemsReducer: {addShoppingCart, deleteShoppingCart}} = this.props;
        let totalbruto = 0;
        let totalneto = 0;
        let unidades = 0;
        let articulos = items.length;
        items.map(item => {        
            let bruto = Number(item.weight1 * item.quantity);
            totalbruto += bruto;
            let neto = Number(item.weight * item.quantity);
            totalneto += neto; 
            let cantidadArti = Number(item.quantity);
            unidades += cantidadArti
        });

        return (
            <div className="container" style={{fontSize: 18}}>
                <div className="row">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Total peso neto: </span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                             {parseFloat(totalneto).toFixed(2)} KG
                        </span>
                    </div>
                </div>
                <div className="row border-bottom">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Total peso bruto:</span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            {parseFloat(totalbruto).toFixed(2)} KG
                        </span>
                    </div>
                </div>
                <div className="row border-bottom">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Total de articulos:</span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            {parseInt(articulos)}
                        </span>
                    </div>
                </div>
                <div className="row border-bottom">
                    <div className="col-6" style={{padding: 0}}>
                        <span className="font-weight-bold">Total de unidades:</span>
                    </div>
                    <div className="col-6 text-right" style={{padding: 0}}>
                        <span className="text-right">
                            {parseInt(unidades)}
                        </span>
                    </div>
                </div>
            </div>
        )
    };

    activarboton = () =>{
        this.setState({
            variable : true,
        });            
    }

    render() {
        const {sessionReducer: {role}} = this.props;
        const {history, shoppingCartReducer: { items }, itemsReducer: {addShoppingCart, deleteShoppingCart}} = this.props;
        const {itemPromociones,Limit, Codigo, CardName, itemsRegalos, itemsBonificacion,selectorType,itemsRegalosSelect,boxes,itemsNotificacion,variable} = this.state;    
        return (
            <div className="content-fluid" style={{marginTop: 69}}>
                <Session history={history} view={VIEW_NAME.SHOPPING_CART_VIEW}></Session>
                <NavBar></NavBar>

                <ItemsPromoModal
                    items = {itemsBonificacion}
                    selectorType = {selectorType}
                    addItemsPromo = {this.addItemsPromo}
                />
                <CreditLimitModal
                    Limit={Limit}
                    Codigo={Codigo}
                    CardName={CardName}
                    createDocument={this.createDocument}
                ></CreditLimitModal>                
                <div className="row mb-4" style={{paddingTop: 60, margin: 0,  minHeight: '70vh'}}>
                    <div className="col-sm-9">
                        <div className="card style-articles-cart" style={{
                                borderColor: 'white',
                                border: '1px solid  rgba(124, 124, 125, 0.3)'
                            }}>

                         

                            <div className="card-header" style={{background: config.shoppingList.productList}}>
                                <div className='row'>
                                    <h5 className="card-title col-12 col-sm-8" style={{color: config.shoppingList.textProductList}}> Artículos en tu carrito <span className="small">(precios con I.G.V):</span></h5>
                                    <div className='text-right col-12 col-sm-4' style={{width: '100%'}}>
                                        {!!items.length &&
                                        <div onClick={() => deleteShoppingCart({item: {}, deleteAll: true})}
                                             className='text-left text-sm-right'
                                             style={{cursor: 'pointer', color: 'red'}}>
                                            <i className="fa fa-trash"/> Eliminar todo
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {!!items.length ? 
                                
                                    <ShoppingCartList
                                        view={VIEW_NAME.SHOPPING_CART_VIEW}
                                        data={items}
                                        deleteItem={deleteShoppingCart}
                                        changeQuantity={this.changeQuantity}
                                        add={addShoppingCart}
                                        sendTo={this.sendToBackOrder}

                                        refeshState = {this.refeshState}
                                        itemPromociones = {itemPromociones}
                                        selectItemsPromo = {this.selectItemsPromo}
                                        itemsRegalos = {itemsRegalos}
                                        itemsRegalosSelect = {itemsRegalosSelect}
                                        deleteItemPromo = {this.deleteItemPromo}
                                        boxes = {boxes}
                                        itemsNotificacion ={itemsNotificacion}
                                        activarboton = {this.activarboton}
                                    ></ShoppingCartList> :
                                    <div className='text-center' style={{fontSize: 30}}>
                                        Carrito vacío
                                    </div>}
                            </div>
                            {/* <div>
                                <h5>Condicion, que beneficio</h5>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="card" style={{
                            borderColor: 'white',
                            backgroundColor: 'transparent',
                            border: '1px solid  rgba(124, 124, 125, 0.3)'
                            }}>
                            <div className="card-header text-white"
                                 style={{background: config.shoppingList.summaryList}}>
                                <div className="card-title">
                                    <h5 style={{color: config.shoppingList.textsummaryList}}>Resumen:</h5>
                                </div>
                            </div>

                            <div className="card-body">
                                {this.renderShoppingCartTotal()}
                                {items.length !== 0 &&
                                    role === ROLES.CLIENT ?
                                    <div className="col-12 text-right p-0 mt-3">
                                        {/* <button type='button' onClick={this.createDocument} className="btn btn-success" style={{ fontWeight: "bold"}}>Continuar compra</button> */}
                                        <button type='button' onClick={this.mostrar} className="btn btn-success" style={{ fontWeight: "bold"}} hidden={variable ? false : true}>Continuar compra</button>
                                    </div>:
                                    <div className="col-12 text-right p-0 mt-3">
                                        <button type='button' onClick={() => { modal.loginModal('show') }} className="btn btn-success" style={{ fontWeight: "bold"}}>Continuar compra</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <br></br>
                        <div className="card" style={{
                            borderColor: 'white',
                            backgroundColor: 'transparent',
                            border: '1px solid  rgba(124, 124, 125, 0.3)'
                             }}>
                            <div className="card-header text-white"
                                 style={{background: config.shoppingList.summaryList}}>
                                <div className="card-title">
                                    <h5 style={{color: config.shoppingList.textsummaryList}}>Detalles:</h5>
                                </div>
                            </div>

                            <div className="card-body">
                                {this.renderShoppingCartDetail()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state,props) => {
    return {
        itemsReducer: state.ItemsReducer,
        sessionReducer: state.SessionReducer,
        configReducer: state.ConfigReducer,
        notificationReducer: state.NotificationReducer,
        shoppingCartReducer: state.ShoppingCartReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setShoppingCart: value => dispatch({type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value}),
        setItemsGift: value => dispatch(
            {
                type: DISPATCH_ID.SHOPPING_CART_ITEMS_GIFT, 
                value
            }
            ),
    };
};



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShoppingCartView);